/**
 * Mappers for system-level transactions (unified Transaction type)
 * to UnifiedTransaction format.
 */

import type { UnifiedTransaction } from '../../../users/query/V2/mappers';
import type { TransactionGraphQL } from './useTransactionsRelay';

/**
 * Map a single GraphQL Transaction to UnifiedTransaction
 */
export function mapTransactionGraphQLToUnified(
  tx: TransactionGraphQL
): UnifiedTransaction {
  const isHold = tx.id.startsWith('pi_');
  const amountCents =
    isHold && tx.holdAmount != null ? tx.holdAmount : (tx.amount ?? 0);
  const amountFormatted = `$${(amountCents / 100).toFixed(2)}`;

  const userName = tx.user
    ? `${tx.user.firstName ?? ''} ${tx.user.lastName ?? ''}`.trim()
    : '';

  const txType = tx.type ?? '';
  const isWallet =
    txType.toLowerCase().includes('wallet') ||
    txType.toLowerCase().includes('transfer');

  return {
    id: tx.id,
    created: tx.created ?? '',
    description: tx.description ?? '',
    type: isHold ? 'hold' : txType,
    amount: amountFormatted,
    status: tx.refundStatus || tx.status || null,
    source: isWallet ? 'wallet' : 'charge',
    userName,
  };
}

/**
 * Map an array of GraphQL Transactions to UnifiedTransaction[]
 */
export function mapSystemTransactionsToUnified(
  transactions: TransactionGraphQL[] = []
): UnifiedTransaction[] {
  return transactions.map(mapTransactionGraphQLToUnified);
}
